import { Injectable } from '@angular/core';

const SELECTED_PLAN_KEY = 'selectedPlan';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  setSelectedPlan(planId: string): void {
    sessionStorage.setItem(SELECTED_PLAN_KEY, planId);
  }

  getSelectedPlan(): string | null {
    return sessionStorage.getItem(SELECTED_PLAN_KEY);
  }

  clearSelectedPlan(): void {
    sessionStorage.removeItem(SELECTED_PLAN_KEY);
  }
}
